@if(isPageInitialized) {
  <div class="dashboard-wrapper" *transloco="let t; prefix: 'maintenanceCosting'">
    <div class="dashboard-top-section d-flex align-items-center justify-content-between">
      @if(!fullViewService.isFullView()) {
        <h1>{{ t('page.title') }}</h1>
      } @else {
        <div class="d-flex align-items-center gap-2">
          <button class="back-button" [title]="t('page.back')" (click)="onBackToMainView()">
            <span>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M20.9999 11H6.41394L11.7069 5.70697L10.2929 4.29297L2.58594 12L10.2929 19.707L11.7069 18.293L6.41394 13H20.9999V11Z" fill="#9FA1A4"/>
              </svg>
            </span>
          </button>
          <h1>{{ t('page.title') }}</h1>
        </div>
      }

      <div class="search-menu-lists d-flex">
        <div class="filters d-flex align-items-center gap-2">
          <app-account-filter [filter]="accountFilter" (filterChanged)="onAccountFilterChange($event)"></app-account-filter>

          <div class="common-drop-down date-height">
            <app-date-filter [filter]="dateFilter" [isButtonIntervalSelector]="false"
              [disabledIntervals]="disabledIntervals" [defaultInterval]="defaultInterval"
              (filterChanged)="onDateFilterChange($event)">
            </app-date-filter>
          </div>

          @if (selectedTab === 'outsourced-maintenance') {
            <button class="btn-customise-column" (click)="onCustomiseColumn()">
              {{ t('page.customiseColumn') }}
            </button>
          }

          <button class="btn-add-contract" (click)="selectedTab === 'ancillary-cost' ? onAddInvoice() : onAddContract()">
            {{ selectedTab === 'ancillary-cost' ? t('page.addInvoice') : t('page.addContract') }}
          </button>
        </div>
      </div>
    </div>

    <div class="dashboard-content">
      @if(!fullViewService.isFullView()) {
        <div class="dashboard-graphs mb-2">
          <div class="row g-3">
            <div class="col-12 col-xl-4 mt-0">
              <app-monthly-cost-comparison></app-monthly-cost-comparison>
            </div>
            <div class="col-12 col-xl-4 mt-0">
              <app-cpk-trend></app-cpk-trend>
            </div>
            <div class="col-12 col-xl-4 mt-0">
              <app-highest-cost-by-contract-type></app-highest-cost-by-contract-type>
            </div>
          </div>
        </div>
      }
      <!-- Tabs -->
      <div class="tabs-container w-100">
        <button class="tab-button" [class.active]="isTabActive('outsourced-maintenance')" (click)="onTabChange('outsourced-maintenance')">{{ t('page.tabs.outsourcedMaintenance') }}</button>
        <button class="tab-button" [class.active]="isTabActive('in-house-maintenance')" (click)="onTabChange('in-house-maintenance')">{{ t('page.tabs.inHouseMaintenance') }}</button>
        <button class="tab-button" [class.active]="isTabActive('ancillary-cost')" (click)="onTabChange('ancillary-cost')">{{ t('page.tabs.ancillaryCost') }}</button>
      </div>

      <!-- Tab Content -->
      <div class="tab-body w-100">
        @if (selectedTab === 'outsourced-maintenance') {
          <app-outsourced-maintenance-contract [selectedColumns]="selectedColumns"></app-outsourced-maintenance-contract>
        } @else if (selectedTab === 'in-house-maintenance') {
          <app-in-house-maintenance></app-in-house-maintenance>
        } @else if (selectedTab === 'ancillary-cost') {
          <app-ancillary-cost></app-ancillary-cost>
        }
      </div>
    </div>
  </div>
}